// @ts-nocheck
/* eslint-disable */
import { createMarkerInfo } from "~/ui/markerinfo";
import { CONFIG } from "~/config";
import { saveHistory } from "~/util/providers/history";
import { store } from "~/state/store";
import { firmStats, isFirmFromPoi } from "~/util/review";
import { openAdminDetail } from "~/util/userweb";
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import Scene from "~/scene";
import { ROUTE_CONST } from "~/route/const";
import { description } from "./util/providers/poiagg";

Mapy.MarkerCard = function MarkerCard() {};

/**
 * naplneni obsahu vizitky
 *
 * @param {object} card   instance SMap.Card
 * @param {object} poi    data pro naplneni vizitky (napr. z getDescription, nebo detailu)
 * @param {Boolean} isDetail jedna se o detail?
 * @param {Function} [rmCb] Vlastni callback pro odstraneni vizitky
 */
Mapy.MarkerCard.prototype._setPopupCont = function _setPopupCont(card, poi, isDetail, rmCb) {
	const isDMorUM = Mapy.getComponent("distanceMeter").isActive() || Mapy.getComponent("userMarks").isActive() || poi.source === "gr";
	// obsah
	const markerInfo = createMarkerInfo({
		poi,
		routeBtnCb: async () => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			if (rmCb) {
				rmCb();
			} else {
				this.removeCard();
			}

			if (CONFIG.inFrame) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${store.getState().map.mapset}?planovani-trasy&y=${poi.mark.lat}&x=${poi.mark.lon}&z=18&rc=${Scene.coordsToString([Scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat)])}&rs=&rs=${poi.source}&ri=&ri=${poi.id}&mrp={"c"%3A111}`);
			} else {
				const route = Mapy.getComponent("route");

				if (!Mapy.CML.state.route?.items?.length) {
					Mapy.CML.state = {
						route: {
							params: {
								criterion: poi.source === "pubt" ? 200 : 111,
								type: poi.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
							},
						},
					};
				}

				await route.addItem({
					source: poi.source,
					position: Mapy.getComponent("route").isActive() ? ROUTE_CONST.position.start : ROUTE_CONST.position.end,
					id: poi.id,
					name: poi.title,
					coords: Scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat),
					desc: poi.multiTitle ? poi.multiTitle.slice(1).join(", ") : poi.title,
					..."typeId" in poi ? {typeId: poi.typeId } : {},
				});
			}

			if (isFirmFromPoi(poi)) {
				this._firmStats("route", poi, { placeId: 9, typeId: 3 });
			}

			if (!CONFIG.inFrame) {
				Mapy.getComponent("history").save();
			}
		},
	});
	var infoPart = markerInfo.info;

	// click eventy
	// pro detail nechceme otevrit znovu detail
	if (!isDetail && !isDMorUM) {
		infoPart.addEventListener("click", function(e) {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}
			if (rmCb) {
				rmCb();
			} else {
				this.removeCard();
			}

			if (CONFIG.inFrame) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${store.getState().map.mapset}?source=${poi.source}&id=${poi.id}`);
			} else if (store.getState().map.mapset === "uzavirky" && poi.past) { // klik na minule uzavirky otevre detail v poiadminu
				openAdminDetail(poi.source, poi.id);
			} else {
				let state = {
					source: poi.source,
					id: poi.id,
					manual: true,
					show: false,
					fromMarker: this
				};

				let search = Mapy.getComponent("search");
				if (search.isActive()) {
					state.search = Mapy.getComponent("detail").getSuggestConf()
				}

				if (this instanceof Mapy.MarkerSearch) {
					const logObj = {
						search_type: "searchmap",
					};
					const filters = Mapy.getComponent("search").getFilters();

					if (Object.keys(filters).length) {
						logObj.filter_id = "";
						logObj.filter_type = "";
						for (let f in filters) {
							logObj.filter_id += (logObj.filter_id !== "" ? "," : "") + filters[f].id;
							logObj.filter_type += (logObj.filter_type !== "" ? "," : "") + filters[f].type;
						}
					}
					Mapy.Util.analyticsSearchSelection(logObj, poi);
				}

				if (!Mapy.Util.linkToNewWindow(e)) {
					e.preventDefault();

					Mapy.getComponent("detail").setState(state).then(function() {
						const { user } = store.getState().user;

						saveHistory(user, {
							title: poi.title,
							source: "web",
							type: "poi",
							data: {
								entitySource: poi.source,
								entityId: poi.id,
								lon: poi.mark.lon,
								lat: poi.mark.lat,
							}
						}).then(() => {}, () => {});
						Mapy.getComponent("history").save();
					}, () => {});

					if (Mapy.Util.isSmallResolution()) {
						Mapy.getComponent("layout").setWidth(1);
					}
				}
			}

			if (isFirmFromPoi(poi)) {
				this._firmStats("detail", poi, { placeId: 9, typeId: 7 });
			}
		}.bind(this));
	}

	var cardBody = card.getBody();
	Mapy.Util.clear(cardBody);
	cardBody.appendChild(infoPart);

	if (!isDMorUM) {
		cardBody.appendChild(markerInfo.seperatorPart);
		cardBody.appendChild(markerInfo.buttonPart);
	}
	else {
		// kdyz najedu na bublinu u dm a um skryju ji
		infoPart.addEventListener("mouseenter", function() {
			this.removeCard();
		}.bind(this));
	}

	if (isFirmFromPoi(poi) && poi.paid) {
		this._firmStats("desc", poi, {placeId: 9});
	}
};

Mapy.MarkerCard.prototype._firmStats = function(type, data, specParam) {
	switch (type) {
		case "route":
		case "detail" :
			firmStats("firmy-vizitka-akce", data, specParam);
			break;
		case "desc":
			firmStats("firmy-vizitka-doruceni", data, specParam);
	}
};

Mapy.MarkerCard.prototype._getDesc = function(poi) {
	var promise = new JAK.Promise();

	description([poi], {
		fetchPhoto: true,
		ratios: ['1x1'],
		lang: CONFIG.langPriority,
		query: Mapy.getComponent("search").getQuery(),
		wikimedia: true,
	}).then(function(r) {
		// merge poi + desc
		if (r.poi && r.poi.length === 1) {
			Object.assign(poi, r.poi[0]);
		}

		// promise is done
		promise.fulfill(poi);
	}, () => {});

	return promise;
};
